import { useState } from 'react';

import MoreVert from '@mui/icons-material/MoreVert';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import PropTypes from 'prop-types';

import DeleteCollectionMenuItem from './DeleteCollectionMenuItem';
import DeleteDocsMenuItem from './DeleteDocsMenuItem';
import ExportMenuItem from './ExportMenuItem';
import ImportMenuItem from './ImportMenuItem';

const ActionMenu = ({ collection, isSolrCloud, onRefresh }) => {
  const [menu, setMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpenMenu = (event, collection) => {
    setAnchorEl(event.target);
    setMenu(collection);
  };

  const handleCloseMenu = () => setMenu(null);

  return (
    <>
      <IconButton
        aria-label="more-actions-icon"
        onClick={(e) => handleOpenMenu(e, collection.name)}
        size="large"
      >
        <MoreVert />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={collection.name === menu}
        onClose={() => handleCloseMenu(collection.name)}
      >
        <ImportMenuItem name={collection.name} onClose={handleCloseMenu} />
        <ExportMenuItem name={collection.name} onClose={handleCloseMenu} />
        <DeleteDocsMenuItem name={collection.name} onClose={handleCloseMenu} />
        <DeleteCollectionMenuItem
          name={collection.name}
          onClose={handleCloseMenu}
          isSolrCloud={isSolrCloud}
          onRefresh={onRefresh}
        />
      </Menu>
    </>
  );
};

ActionMenu.propTypes = {
  collection: PropTypes.object.isRequired,
  isSolrCloud: PropTypes.bool,
  onRefresh: PropTypes.func.isRequired,
};

export default ActionMenu;
